'use strict';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

// components
import { ModalStepper } from 'dumb';

// batch view
import ProductVariantGroupProductVariantsBatchStepForm from './components/productVariantGroupProductVariantsBatchStepForm';
import ProductVariantGroupProductVariantsBatchStepList from './components/productVariantGroupProductVariantsBatchStepList';

// lodash
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _uniqueId from 'lodash/uniqueId';

// phrases
import phrases from './../../productVariantGroupProductVariants.phrases';

class ProductVariantGroupProductVariantsModalBatch extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loadingModal: false,
		};

		this.modalRef = React.createRef();

		this._goToStep = this._goToStep.bind(this);
		this._submitValues = this._submitValues.bind(this);
		this._batchSubmit = this._batchSubmit.bind(this);
	}

	_batchSubmit() {
		const {
			batchList,
			handleClose,
			addProductVariantGroupProductVariants,
			productVariantGroupId,
		} = this.props;

		this.setState(() => ({
			loadingModal: true,
		}));

		const payload = batchList.map((entry) => {
			return {
				product_variant_group: productVariantGroupId,
				product_variant: _get(entry, 'productVariant.value.id', null),
			};
		});

		addProductVariantGroupProductVariants({ batch: payload })
			.then(() => {
				handleClose();
				this.setState(() => ({
					loadingModal: false,
				}));
			})
			.catch(() => {
				this.setState(() => ({
					loadingModal: false,
				}));
			});
	}

	_submitValues() {
		const { batchForm, addBatchList } = this.props;

		const values = batchForm.productVariant.map((entry) => ({
			identifier: _uniqueId('row-'),
			productVariant: entry,
		}));

		addBatchList(values);

		this._goToStep(2);
	}

	_goToStep(step) {
		this.modalRef.current.goToStep(step);
	}

	render() {
		const {
			modalVisible,
			handleClose,
			batchList,
			editBatchListItem,
			removeBatchListItem,
			addBatchListItemRow,
			batchForm,
			updateBatchForm,
		} = this.props;

		const steps = [
			{
				component: (
					<ProductVariantGroupProductVariantsBatchStepForm
						batchForm={batchForm}
						updateBatchForm={updateBatchForm}
					/>
				),
				title: phrases.MODAL_BATCH_STEP_FORM_TITLE,
				isValid: !_isEmpty(batchForm.productVariant),
				onNext: this._submitValues,
				noScroll: false,
				confirmButtonLabel: phrases.MODAL_BATCH_STEP_FORM_CONFIRM_BUTTON_LABEL,
			},
			{
				component: (
					<ProductVariantGroupProductVariantsBatchStepList
						batchList={batchList}
						editBatchListItem={editBatchListItem}
						removeBatchListItem={removeBatchListItem}
						addBatchListItemRow={addBatchListItemRow}
					/>
				),
				title: phrases.MODAL_BATCH_STEP_LIST_TITLE,
				isValid: true,
				onNext: this._batchSubmit,
				onBack: () => this._goToStep(1),
				loading: this.state.loadingModal,
				confirmButtonLabel: phrases.MODAL_BATCH_STEP_LIST_CONFIRM_BUTTON_LABEL,
				cancelButtonLabel: phrases.MODAL_BATCH_STEP_LIST_CANCEL_BUTTON_LABEL,
				defaultStyles: false,
				noScroll: false,
			},
		];

		return modalVisible ? (
			<ModalStepper
				ref={this.modalRef}
				isOpen={modalVisible}
				steps={steps}
				showStep={false}
				onClose={handleClose}
			/>
		) : null;
	}
}

ProductVariantGroupProductVariantsModalBatch.propTypes = {
	modalVisible: PropTypes.bool,
	handleClose: PropTypes.func,
	batchList: PropTypes.array,
	editBatchListItem: PropTypes.func,
	removeBatchListItem: PropTypes.func,
	addBatchListItemRow: PropTypes.func,
	addProductVariantGroupProductVariants: PropTypes.func,
	productVariantGroupId: PropTypes.number,
	batchForm: PropTypes.object,
	updateBatchForm: PropTypes.func,
	addBatchList: PropTypes.func,
};

export default ProductVariantGroupProductVariantsModalBatch;
